import RoiCampaigns from '@Web/Src/UI/Roi/Components/RoiCampaigns';
import SectionHeader from '@Web/Src/Components/SectionHeader';
import RoiItem from '@Web/Src/UI/Roi/Components/RoiItem';
import { ROI, ROI_STATS } from '@Web/Src/constants.js';
import LinkSection from '@Web/Src/UI/LinkSection';
import { router } from '@inertiajs/react';
import { useState } from 'react';

function Roi({ showLink = true }) {
    const [active, setActive] = useState(ROI[0]);
    const [isHovered, setIsHovered] = useState(null);

    const data = ROI_STATS[active.value];

    const handleExample = () => {
        router.visit(route('web.pages.campaign_examples'));
    };

    return (
        <div className='mt-32 w-full'>
            <SectionHeader
                type='dark'
                className='mx-auto mt-24'
                icon='roi'
                title={__('What’s the ROI of our referral platform?')}
                desc={__(
                    'Get up to 30% more leads every year with referral tracking software. All you need to do is launch a referral program. Consumers are 3x more likely to choose you when referred, making referral software a powerful growth tool.'
                )}
            />
            <div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(null)}
                className='small:flex-col small:text-center mx-auto mt-10 flex w-full max-w-[700px] gap-5 overflow-x-scroll pb-5'
            >
                {ROI.map((item) => {
                    return (
                        <h3
                            onClick={() => setActive(item)}
                            className={`bg-light cursor-pointer whitespace-nowrap rounded-3xl px-4 py-2 text-xl font-semibold ${active.header === item.header ? '!bg-blue text-light' : 'text-tertiary bg-inherit'}`}
                            key={item.header}
                        >
                            {item.header}
                        </h3>
                    );
                })}
            </div>
            <div className='medium:block mx-auto flex h-full w-full max-w-[940px] flex-wrap items-center justify-between gap-14 py-16'>
                <div className='medium:mx-auto max-w-[400px] flex-1'>
                    {data.map((item, index) => {
                        return <RoiItem key={index} item={item} />;
                    })}
                </div>
                <RoiCampaigns isHovered={isHovered} item={active} />
            </div>
            {showLink && (
                <LinkSection
                    handleClick={handleExample}
                    link={__('See more referral program examples')}
                />
            )}
        </div>
    );
}

export default Roi;
